import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0.625469 11.3028V12.5921C0.625469 14.0822 1.72056 15.3212 3.14819 15.5468V16.5H4.08572V15.5836H11.9138V16.5H12.8514V15.5468C14.279 15.3212 15.3741 14.0822 15.3741 12.5921V11.3028H0.625469ZM1.563 8.48872V3.07987C1.563 2.17428 2.29978 1.43753 3.20537 1.43753C4.04406 1.43753 4.73744 2.06953 4.83541 2.88222C3.85916 3.10209 3.12756 3.97556 3.12756 5.01725V5.64237H7.50544V5.01725C7.50544 3.96806 6.76331 3.08937 5.77659 2.87737C5.67281 1.54922 4.55969 0.5 3.20537 0.5C1.78281 0.5 0.625469 1.65731 0.625469 3.07987V8.48872H0V10.3652H15.9996V8.48872H1.563Z",
  fill: "#717179"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}